// Fixed portrait 9:16 design surface. Kept in a dependency-free module so both
// JKGame_config (which imports the scenes) and the scenes can import it without
// forming an import cycle (a cycle here causes a const TDZ crash at boot).
export const DESIGN_WIDTH = 540
export const DESIGN_HEIGHT = 960
